import React from 'react';
import { parseMarkdown } from '../utils/markdownParser';
import MarkdownTable from './MarkdownTable';
import InlineContent from './InlineContent';

const MessageContent = ({ content, isAi }) => {
  const blocks = parseMarkdown(content);
  return (
    <div className="w-full">
      {blocks.map((block, i) => {
        if (block.type === 'table') return <MarkdownTable key={i} tableLines={block.raw} />;
        if (block.type === 'spacer') return <div key={i} className="h-2" />;
        if (block.type === 'paragraph') {
          return (
            <p key={i} className="leading-relaxed">
              <InlineContent text={block.raw} dark={!isAi} />
            </p>
          );
        }
        return null;
      })}
    </div>
  );
};

export default MessageContent;